import { render, staticRenderFns } from "./sendGreeting.vue?vue&type=template&id=09078bc1&scoped=true&"
import script from "./sendGreeting.vue?vue&type=script&lang=js&"
export * from "./sendGreeting.vue?vue&type=script&lang=js&"
import style0 from "./sendGreeting.vue?vue&type=style&index=0&id=09078bc1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09078bc1",
  null
  
)

export default component.exports